import type { ReactElement } from "react";
import styles from "./Spacer.module.css";

export type SpacerSize = "xs" | "sm" | "md" | "lg" | "xl";

export interface SpacerProps {
  /**
   * Vertical size of the spacer block (height in px).
   * Defaults to `sm` (12px) — the rhythm used between inspector rows.
   */
  size?: SpacerSize;
  /**
   * Hide the 1px bottom hairline when an adjacent element already draws
   * its own divider.
   */
  noBorder?: boolean;
}

const SIZE_CLASS: Record<SpacerSize, string> = {
  xs: styles.xs,
  sm: styles.sm,
  md: styles.md,
  lg: styles.lg,
  xl: styles.xl
};

/**
 * Vertical rhythm block with an optional 1px bottom hairline. Use `noBorder`
 * for a gap-only spacer, or pair a bordered spacer with a `noBorder` sibling
 * when you need a divider plus extra inset (common in inspector cards).
 */
export function Spacer({ size = "sm", noBorder = false }: SpacerProps): ReactElement {
  const className = [
    styles.spacer,
    SIZE_CLASS[size],
    noBorder ? styles.noBorder : null
  ]
    .filter(Boolean)
    .join(" ");

  return <div className={className} aria-hidden />;
}
